import { api } from "../../util";

export const getVideosApiCall = (payload = {}) => {
  let url = "/videos";

  return api.get(url, {
    params: {
      page: payload.page,
      limit: payload.limit,
      filter: payload.filter || {},
      sort: payload.sort,
      //   search: payload.search,
    },
  });
};
